import { useTranslation } from 'react-i18next';
import { useStudioStore } from '@/store/useStudioStore';
import { useChatStore } from '@/store/useChatStore';
import { Icon } from '@iconify/react';
import { trackEvent } from '@/api/track';

/** 发布项目按钮组件 */
export const StudioPublishButton = () => {
  const { t } = useTranslation('studio');
  const { iframeUrl, isBuilding, setPublishModalOpen, currentProjectId } = useStudioStore();
  const { isBuildFailed } = useChatStore();

  const isLoading = isBuilding && !iframeUrl && !isBuildFailed;
  const isDisabled = (isBuilding && !iframeUrl) ?? false;

  return (
    <button
      disabled={isDisabled}
      onClick={() => {
        trackEvent({
          eventCode: 'app_publish_click',
          eventData: JSON.stringify({ app_id: currentProjectId, create_method: 'brief' }),
        });
        setPublishModalOpen(true);
      }}
      className="flex cursor-pointer items-center gap-[7px] rounded-[9px] border-none bg-gradient-to-br from-[#6D28D9] to-[#0891B2] px-[20px] py-[9px] text-[13.5px] font-[700] whitespace-nowrap text-white transition-opacity hover:opacity-90 disabled:cursor-default disabled:opacity-60"
    >
      {isBuildFailed ? (
        <Icon icon="fa6-solid:triangle-exclamation" />
      ) : isLoading ? (
        <Icon icon="fa6-solid:spinner" className="animate-spin" />
      ) : (
        <Icon icon="fa6-solid:rocket" />
      )}
      {isBuildFailed
        ? t('build.status.failed_badge', 'Build failed')
        : isLoading
          ? t('build.status.building')
          : t('publish.publish')}
    </button>
  );
};
